import React, {useLayoutEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import SupportForm from "../../components/Forms/SupportForm";
import {message} from "antd";
import {
	Layout, Row, Col, Card, Space, Typography, Button, Input, Select,
	Divider, Tooltip, Badge, Spin, Pagination, notification, Alert
} from "antd";
import {
	PlusOutlined,
	ReloadOutlined,
} from "@ant-design/icons";
import {fetchWrapper} from "../../helpers";
import AppNavigation from "../../components/AppNavigation";
import {ImeanHeader} from "../../components/Header/Header";
import {StickyNavigationHeader} from "../../components/Navigation/StickyNavigationHeader";

const baseUrl = `${process.env.REACT_APP_API_URL}`;
const Support = () => {
	const navigate = useNavigate();
	const {t} = useTranslation();

	function clearAndRefreshCache() {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.ready.then(registration => {
				registration.active.postMessage({ type: 'CLEAR_CACHE' });
				localStorage.setItem('cacheHasRefreshed', new Date().toISOString());
				window.location.reload();
			}).catch((error) => {
				message.error(`${t("functions.error:")} ${error.message ? error.message : error}`);
			});
		}
	}

	useLayoutEffect(() => {
		const differenceTime = Number(((new Date() - new Date(localStorage.getItem('cacheHasRefreshed'))) / 1000 / 60).toFixed(1));
		if (differenceTime < 0.5) {
			message.success(t("support.clearCacheSuccess"));
			// sessionStorage.removeItem('cacheHasRefreshed');
		}
	}, []);

	return (
		<Layout className="min-h-screen bg-gradient-to-b from-white to-violet-50">
			{/* Header */}
			<ImeanHeader initialDark={true}></ImeanHeader>
            <StickyNavigationHeader headerTitle={t('support.header')} onBackClick={() => navigate('/home')}></StickyNavigationHeader>
			{/* Main */}
			<Layout.Content className="max-w-6xl mx-auto w-full px-4 md:px-6 lg:px-8 py-6">
				<Row gutter={[16, 16]}>
					{/* Left: Support form */}
					<Col xs={24} lg={14}>
						<Card className="shadow-sm rounded-2xl" bodyStyle={{ padding: 16 }} title={t("support.supportCardTitle")}>
							<SupportForm />
						</Card>
					</Col>

					{/* Right: Help & troubleshooting */}
					<Col xs={24} lg={10}>
						<Space direction="vertical" size={16} className="w-full">
							<Card className="shadow-sm rounded-2xl" bodyStyle={{ padding: 16 }} title={t("support.troubleShooting.title")}>
								<Space direction="vertical" size={12} className="w-full">
									<Typography.Paragraph type="secondary" className="!mb-0">
                                        {t("support.troubleShooting.hint")}
									</Typography.Paragraph>
									<Alert
										type="info"
										showIcon
										className="rounded-lg"
										message={t("support.troubleShooting.alert.title")}
										description={t("support.troubleShooting.alert.description")}
									/>
									<Button type="primary" className="!rounded-lg" onClick={clearAndRefreshCache}>
                                        {t("support.troubleShooting.alert.buttonClear")}
									</Button>
								</Space>
								<Divider />
								<Space direction="vertical" size={8} className="w-full">
									<Typography.Text type="secondary" className="text-xs">
                                        {t("support.troubleShooting.alert.footerTip")}
									</Typography.Text>
								</Space>
							</Card>

							<Card className="shadow-sm rounded-2xl" bodyStyle={{ padding: 16 }} title={t("support.contactCard.title")}>
								<Space direction="vertical" size={8} className="w-full">
									<Typography.Text>Email: info@diffuz.io</Typography.Text>
									<Typography.Text type="secondary">{t("support.contactCard.hint")}</Typography.Text>
								</Space>
							</Card>
						</Space>
					</Col>
				</Row>
			</Layout.Content>

			<AppNavigation />
		</Layout>
	);
};

export default Support;